// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import store from './store'
import router from './router'
import VuesticPlugin from '@/vuestic-theme/vuestic-plugin'
import './i18n'
import YmapPlugin from 'vue-yandex-maps'
import VueSweetalert2 from 'vue-sweetalert2'
import wysiwyg from 'vue-wysiwyg'

import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import VueSocketIO from 'vue-socket.io'
// Now setup our socket and vuex configuration
// Vue.use(
//   new VueSocketIO({
//     debug: true,
//     connection: 'https://amiproxy.innoshop.co?auth=200'
//   })
// )
Vue.use(wysiwyg, {}) // config is optional. more below
Vue.use(VueSweetalert2)
Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
